const POST_URL_PATTERN =
  /(?:https?:\/\/[^\s/]+)?\/posts?\/([a-fA-F0-9]{24})\/?(?:\?[^\s]*)?/i;

const isNoiseNote = (note) => !note || /^\d+$/.test(note);

export function parseSharedPostMessage(text) {
  if (!text || typeof text !== "string") return null;

  const match = text.match(POST_URL_PATTERN);
  if (!match) return null;

  const postId = match[1];
  const urlStart = match.index;
  const urlEnd = urlStart + match[0].length;

  const before = text.slice(0, urlStart).trim();
  const after = text.slice(urlEnd).trim();
  const rawNote = [before, after].filter(Boolean).join("\n").trim();
  const noteText = isNoiseNote(rawNote) ? null : rawNote;

  return {
    postId,
    postPath: `/post/${postId}`,
    noteText,
  };
}

export function getMessagePreviewText(text, maxLength = 50) {
  if (!text || typeof text !== "string") return "";

  const shared = parseSharedPostMessage(text);
  if (shared) {
    if (shared.noteText) {
      if (shared.noteText.length <= maxLength) return shared.noteText;
      return `${shared.noteText.slice(0, maxLength)}…`;
    }
    return "Shared a post";
  }

  const singleLine = text.replace(/\s+/g, " ").trim();
  if (singleLine.length <= maxLength) return singleLine;
  return `${singleLine.slice(0, maxLength)}…`;
}
